module.exports = __webpack_public_path__ + "static/media/ri-icon-example.ebefe28b.svg";